"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.tryToRefreshTokens = tryToRefreshTokens;
exports.default = _callee;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _effects = require("redux-saga/effects");

var _actions = require("../actions");

var _actionType = require("../actionType");

var _selectors = require("../selectors");

var _config = _interopRequireDefault(require("./config"));

var _marked =
/*#__PURE__*/
_regenerator.default.mark(tryToRefreshTokens),
    _marked2 =
/*#__PURE__*/
_regenerator.default.mark(_callee);

function tryToRefreshTokens(action) {
  var tokens, refreshedTokens;
  return _regenerator.default.wrap(function tryToRefreshTokens$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return (0, _effects.select)(_selectors.authTokens);

        case 2:
          tokens = _context.sent;
          _context.next = 5;
          return (0, _effects.put)((0, _actions.startTokenRefresh)(tokens));

        case 5:
          _context.prev = 5;
          _context.next = 8;
          return _config.default.remoteRefreshTokens((0, _objectSpread2.default)({}, action.tokens, tokens));

        case 8:
          refreshedTokens = _context.sent;
          _context.next = 11;
          return (0, _effects.put)((0, _actions.setTokens)(refreshedTokens));

        case 11:
          _context.next = 13;
          return (0, _effects.put)((0, _actions.stopTokenRefresh)(null, refreshedTokens));

        case 13:
          _context.next = 21;
          break;

        case 15:
          _context.prev = 15;
          _context.t0 = _context["catch"](5);
          _context.next = 19;
          return (0, _effects.put)((0, _actions.stopTokenRefresh)(_context.t0));

        case 19:
          _context.next = 21;
          return (0, _effects.put)((0, _actions.logout)());

        case 21:
        case "end":
          return _context.stop();
      }
    }
  }, _marked, this, [[5, 15]]);
}

function _callee() {
  return _regenerator.default.wrap(function _callee$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return (0, _effects.takeEvery)(_actionType.PROCESS_TOKEN_REFRESH, tryToRefreshTokens);

        case 2:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2, this);
}